import Handlebars from "handlebars";

export default class RenderCards {
  config = {
    list: [],
    resultElement: null,
    templateId: null,
    noResults: null,
  };

  // data fields to replace
  static fieldReplace = [
    "id",
    "name",
    "url",
    "thumbnail",
    "category",
    "tagline",
    "summary",
  ];

  constructor(config) {
    this.config = { ...this.config, ...config };
  }

  render() {
    if (this.config.list.length) {
      if (this.config.resultElement) {
        var baseTemplate = document.getElementById(
          this.config.templateId + "-handlebars"
        ).innerHTML;
        if (baseTemplate) {
          return this.renderByHandlebars(baseTemplate);
          //return this.renderByScript(baseTemplate);
        }
      }
    } else {
      return this.config.noResults;
    }
  }

  renderByHandlebars(baseTemplate) {
    // create a new property for each object in the list, which is a base64 encoded version
    // of the object
    for (var key in this.config.list) {
      this.config.list[key]["bookmarkData"] = btoa(
        JSON.stringify(this.config.list[key])
      );
    }

    Handlebars.registerHelper("encodeMyString", function (inputData) {
      return new Handlebars.SafeString(inputData);
    });

    Handlebars.registerHelper("hasValidTags", function (tags) {
      return tags && tags.length > 0 && !(tags.length === 1 && tags[0] === "");
    });

    const template = Handlebars.compile(baseTemplate);
    return template({ list: this.config.list });
  }

  renderByScript(baseTemplate) {
    var html = [];
    for (var key in this.config.list) {
      var template = structuredClone(baseTemplate);
      RenderCards.fieldReplace.forEach((field) => {
        var replacement = new RegExp("{{" + field + "}}", "g");
        var target = this.config.list[key][field];
        template = template.replace(
          replacement == "undefined" ? "" : replacement,
          typeof target == "undefined" ? "" : target
        );
      });

      // append the base64 encoding
      template = template.replace(
        "{{bookmarkData}}",
        btoa(JSON.stringify(this.config.list[key]))
      );
      html.push(template);
    }
    return html.join("\r\n");
  }

  hydrate() {
    try {
      //console.log(window.squiz.fn.BookmarkButtons.config);
      if (typeof window.squiz.fn.BookmarkButtons?.init !== "undefined") {
        window.squiz.fn.BookmarkButtons.init();
      }
    } catch (e) {
      console.log(
        "Could not hydrate BookmarkButtons after BookmarksPage render",
        e
      );
    }
  }
}
